/**
 * Dictionary loader for Spelling Blitz.
 * Fetches the word list from the public folder and returns an array of lowercase words.
 * Loads and caches the word list from /spelling-blitz/dictionary.json; exports loadDictionary() 
 * (async) and getCachedDictionary() — dictionary.js:1
 */

let cachedDictionary = null;

export async function loadDictionary() {
  if (cachedDictionary) return cachedDictionary;

  try {
    const res = await fetch('/spelling-blitz/dictionary.json');
    if (!res.ok) throw new Error(`Failed to load dictionary: ${res.status}`);
    const words = await res.json();
    cachedDictionary = words.map(w => w.toLowerCase());
    return cachedDictionary;
  } catch (e) {
    console.error('Dictionary load error:', e);
    return [];
  }
}

export function getCachedDictionary() {
  return cachedDictionary || [];
}
